/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField, Tooltip } from "@mui/material";
import { ReactComponent as Settings } from "assets/images/icons/common/settings-with-border.svg";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import LabelledField from "components/labelled-field";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ComponentLinkListItemWrapper from "./component-link-list-wrapper";
import { LinkListLink } from "./link";
import SettingsDialog from "./settings-dialog";

const LinksListComponentEdit = () => {

    const { component, update, updateFactory } = useUpdateComponent();

    const {
        title,
        settings,
        links,
    } = component || {};
    const { t } = useTranslation();
    
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const onTitleChange = (event) => {
        const title = event.target.value;
        update("title", title);
    };

    const onSettingsChange = updateFactory("settings");
    const onLinksChange = updateFactory("links");

    return (
        <div className='simplicity-editor-frame'>
            <LabelledField label={`${t("commons.title")} :`}>
                <TextField
                    id='section_list_title'
                    fullWidth={true}
                    value={title}
                    placeholder={t("commons.addListTitleOptional")}
                    onChange={onTitleChange}
                />
            </LabelledField>
            <div style={{ paddingTop: 12 }}>
                <Tooltip
                    title={t("commons.linkSettings")}
                    placement='top'
                    arrow
                    classes={{ arrow: "arrow", tooltip: "tooltip" }}
                >
                    <Settings
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                    />
                </Tooltip>
                
                {/* FIXME: need to change settings to call update */}
                <SettingsDialog
                    open={open}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    settings={settings}
                    onSettingsChange={onSettingsChange}
                />
            </div>
            
            {links &&
                <ComponentLinkListItemWrapper
                    links={links}
                    onItemChange={onLinksChange}
                >
                    <LinkListLink/>
                </ComponentLinkListItemWrapper>
            }
            
            {/*{localState.links &&*/}
            {/*    localState.links?.map((link, idx) => (*/}
            {/*        <Link*/}
            {/*            key={`link-${idx}`}*/}
            {/*            idx={idx}*/}
            {/*            // setStyle={setStyle}*/}
            {/*            localStateLink={link}*/}
            {/*            localState={localState}*/}
            {/*            setLocalState={setLocalState}*/}
            {/*        />*/}
            {/*    ))*/}
            {/*}*/}
        </div>
    );
};
LinksListComponentEdit.displayName = "LinksListComponentEdit";
export { LinksListComponentEdit };
